// extracted by mini-css-extract-plugin
module.exports = {"container":"AnswerList_container__EUOhq","off":"AnswerList_off__26vzp"};